import React from 'react';
import './Facilities.scss';
import Breadcrumb from '../../components/common/Breadcrumb';
import { useLocation, useNavigate } from 'react-router-dom';

const Facilities = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const facilityList = [
    {
      title: '리와인더 (Rewinder #1)',
      img: '/images/sec1.png',
    },
    {
      title: '리와인더 (Rewinder #2)',
      img: '/images/sec2.png',
    },
    {
      title: '수동슬리팅기 (Manual Log Slitter)',
      img: '/images/sec3.png',
    },
    {
      title: '자동슬리팅기 (Auto Slitter)',
      img: '/images/sec4.png',
    },
  ];

  return (
    <div className="sub-page facilities-page">
      {/* 1. 상단 비주얼: 진한 그라데이션 적용됨 */}
      <section className="sub-visual facilities">
        <div className="container">
          <span className="sub-title">OUR FACILITIES</span>
          <h1>보유설비</h1>
          <p>최첨단 자동화 설비로 최고의 품질과 최적의 솔루션을 약속합니다.</p>
        </div>
      </section>

      <Breadcrumb />

      {/* 2. 카테고리 네비게이션 */}
      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/production/facilities')} onClick={() => navigate('/production/facilities')}>
              보유설비
            </button>
            <button className={isActive('/production/process')} onClick={() => navigate('/production/process')}>
              제조공정
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        {/* 3. 상단 작업 영상 섹션 */}
        <div className="top-video-divider">
          <video autoPlay muted loop playsInline>
            <source src="/videos/facility_main.mp4" type="video/mp4" />
          </video>
          <div className="divider-content">
            <span className="kicker">PRECISE TECHNOLOGY</span>
            <h2>0.1mm의 오차도 허용하지 않는 정밀 가공 시스템</h2>
          </div>
        </div>

        {/* 4. 설비 그리드 섹션 */}
        <div className="facility-grid">
          {facilityList.map((item, idx) => (
            <div key={idx} className="facility-item">
              <div className="img-box">
                <img src={item.img} alt={item.title} />
                <div className="overlay">
                  <span className="view-more">BEST TRADING</span>
                </div>
                <span className="num">0{idx + 1}</span>
              </div>
              <div className="txt-box">
                <div className="title-area">
                  <span className="line"></span>
                  <h3>{item.title}</h3>
                </div>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 5. 최하단 기술력 강조 섹션 */}
        <div className="total-quality-section">
          <div className="total-img">
            <img src="/images/sec5.png" alt="전체 설비 라인" />
            <div className="badge">TOTAL SOLUTION</div>
          </div>
          <div className="total-info">
            <div className="info-inner">
              <span className="label">Quality Control</span>
              <h2>오차 제어 및 공정 최적화</h2>
              <p className="main-p">
                베스트트레이딩은 원단 입고부터 리와인딩, 슬리팅까지 전 공정을
                <strong> 실시간 오차 감지 시스템</strong>으로 관리하여 최상의 품질을 유지합니다.
              </p>
              <ul className="spec-list">
                <li>
                  <strong>장력 제어 시스템</strong>
                  <span>원단별 최적의 텐션 유지로 제품 변형 및 늘어짐 방지</span>
                </li>
                <li>
                  <strong>0.1mm 정밀 컷팅</strong>
                  <span>미세한 규격 차이까지 제어하는 정밀 칼날 세팅 기술</span>
                </li>
                <li>
                  <strong>검수 프로세스 강화</strong>
                  <span>가공 직후 즉각적인 규격 측정 및 불량 실시간 선별</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facilities;
